/**
 * Embed mode addresses (src/lib/embed.ts has the rest). Pure, no DOM: also run by the Node tests.
 */
export const EMBED_PARAM = 'embed';

/** Addresses never shown inside a frame: they open as a full page in a new tab. */
const NEVER_FRAMED = /^\/(staff|add|embed-code|api|feeds)(\/|$)/;

/** The page an /embed address opens: '/embed' is the ask page, '/embed/records' the records; null for any other path. */
export function embedRewrite(pathname: string): string | null {
  const path = pathname.replace(/\/+$/, '') || '/';
  const m = /^\/embed(\/.*)?$/.exec(path);
  return m ? m[1] || '/' : null;
}

/** Whether a path may be shown inside the frame (not staff, /add, the embed code page, files or feeds). */
export function framable(pathname: string): boolean {
  return !NEVER_FRAMED.test(pathname);
}

/** A same-origin address with ?embed=1 added (relative in, relative out); other addresses come back unchanged. */
export function withEmbed(href: string, base: string): string {
  let url: URL;
  try {
    url = new URL(href, base);
  } catch {
    return href;
  }
  if (url.origin !== new URL(base).origin || !framable(url.pathname)) return href;
  if (url.searchParams.get(EMBED_PARAM) === '1') return /^https?:/i.test(href) ? url.toString() : url.pathname + url.search + url.hash;
  url.searchParams.set(EMBED_PARAM, '1');
  return /^https?:/i.test(href) ? url.toString() : url.pathname + url.search + url.hash;
}

/** The full portal's address for an embed address: the same page, without ?embed=1 (and without ?theme=). */
export function fullPortalUrl(href: string): string {
  const url = new URL(href);
  url.searchParams.delete(EMBED_PARAM);
  url.searchParams.delete('theme');
  return url.toString();
}

/** Screens shown at the frame's own height rather than their content's (they fill the screen themselves). */
export function fillsFrame(pathname: string): boolean {
  return /^\/(map|documents)(\/|$)/.test(pathname);
}
